import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Media } from "./types";

interface EditionFormProps {
  selectedEdition: {
    edition_id: number;
    print_price: number | null;
    default_media?: number | null;
    certified?: boolean | null;
  } | null;
  mediaTypes?: Media[];
  onCancel: () => void;
  onSubmit: () => void;
  onPrintPriceChange: (value: number) => void;
  onMediaTypeChange: (value: string) => void;
  onCertifiedChange?: (value: boolean) => void;
}

export function EditionForm({ 
  selectedEdition, 
  mediaTypes, 
  onCancel, 
  onSubmit,
  onPrintPriceChange,
  onMediaTypeChange,
  onCertifiedChange
}: EditionFormProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label htmlFor="print_price" className="text-sm font-medium">Print Price</label>
        <Input
          id="print_price"
          type="number"
          value={selectedEdition?.print_price || 0}
          onChange={(e) => onPrintPriceChange(parseFloat(e.target.value) || 0)}
          placeholder="Enter print price"
        />
      </div>
      <div className="space-y-2">
        <label htmlFor="media_type" className="text-sm font-medium">Media Type</label>
        <Select
          value={selectedEdition?.default_media?.toString() || undefined}
          onValueChange={onMediaTypeChange}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select media type" />
          </SelectTrigger>
          <SelectContent>
            {mediaTypes?.map((media) => (
              <SelectItem key={media.media_id} value={media.media_id.toString()}>
                {media.media_name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center space-x-2">
        <Switch
          id="certified"
          checked={selectedEdition?.certified || false}
          onCheckedChange={onCertifiedChange}
        />
        <Label htmlFor="certified">Certified Edition</Label>
      </div>
      <div className="flex justify-end space-x-2">
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={onSubmit}>
          Save Changes
        </Button>
      </div>
    </div>
  );
}